import { getUserAuditTrail } from '@appt-digital/frontend-api-lib-sheffmed'
import React, { useContext, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '../../ui-library/components/Typography'
import { useFormik } from 'formik'
import { productSchema } from '../../config/validation'
import {
  deleteAppUser,
  editAppUser,
  resetAppUser,
} from '../../handlers/requests/users/appUsersHandler'

import { editProduct } from '../../handlers/requests/sheffmed/products'

import ConfirmationModal from '../../ui-library/components/dialogs/ConfirmationModal'
import { AlertContext } from '../../context/AlertContext'
import TextField from '../../ui-library/components/TextField'
import Dropdown from '../../ui-library/components/Dropdown'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import Button from '../../ui-library/components/Button'
import Link from '../../ui-library/components/Link'

import Image from '../../ui-library/components/Image'


import { FaUser } from 'react-icons/fa'
import { MdDeleteForever, MdDownload } from 'react-icons/md'
import { ThemeContext } from '../../ui-library/components/ThemeContext'
import DashboardContainer from '../../ui-library/components/DashboardContainer'

import DropZone from '../../ui-library/components/DropZone'


import TabHeader from '../../ui-library/components/TabHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import toCapitalised from '../../utils/capitaliseString'
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '../../ui-library/components/DataTable'
import uuid from 'react-uuid'
import dayjs from 'dayjs'
import { Divider, Grid } from '@mui/material'

function EditOrder() {
  const [setLoading] = useState(false)
  const { setAlert } = useContext(AlertContext)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmReset, setConfirmReset] = useState(false)
  const [audit, setAudit] = useState([])
  const { theme } = useContext(ThemeContext)
  const { state } = useLocation()
  const navigate = useNavigate()
  const initialEdit = {
    title: state?.product?.title || '',
    summary: state?.product?.summary || '',
    description: state?.product?.description || '',
    priceDefault: state?.product?.priceDefault || '',
    priceTierOne: state?.product?.priceTierOne || '',
    priceTierTwo: state?.product?.priceTierTwo || '',
    priceTierThree: state?.product?.priceTierThree || ''
  }

  const [productImage, setProductImage] = useState()

  useEffect(() => {
    console.log('state', state)

    setProductImage(state?.product?.record?.signedUrl)
  }, [])

  const [selectedOrgs] = useState([])
  const [title, setTitle] = useState(
    {
      label: state?.user?.title,
      value: state?.user?.title,
    } || { label: 'Mrs', value: 'mrs' }
  )
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialEdit,
      validationSchema: productSchema,
      onSubmit: async () => await handleEdit(),
    })
  const handleEdit = async () => {
    await editProduct(
      state?.product?.id,
      values
    )

    // setAlert,
    setLoading(false)
    navigate('/dashboard/products')
  }
  useEffect(() => {
    const getAuditTrail = async () => {
      const res = await getUserAuditTrail(state?.user?.id)
      setAudit(res?.data)
    }
    getAuditTrail()
  }, [])
  return (
    <>
      <DashboardContainer>
        <TabHeader
          title={'View Order'}
          username={
            state?.user?.firstname !== null &&
            state?.user?.firstname !== undefined &&
            state?.user?.lastname !== null &&
            state?.user?.lastname !== undefined &&
            `${toCapitalised(state?.user?.firstname)} ${toCapitalised(
              state?.user?.lastname
            )}`
          }
        >
          <Paper style={theme?.dashboard?.container}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                <Link
                  type="submit"
                  onClick={() => {
                    navigate('/dashboard/orders')
                  }}
                >
                  {`< Back`}
                </Link>


                <Typography source={'h1'} style={{ marginTop: 20 }}>Order Details</Typography>

                <Divider sx={{ marginTop: '20px', marginBottom: '5px' }} />


                <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                   <Grid container spacing={[3]} sx={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                      <Grid item sm={12} md={6} lg={6} xl={6}>
                        <Typography source={'h2'} style={{ marginTop: 20 }}>Customer Details</Typography>
                          <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                          > 

                            {state?.order?.user?.companyName && <>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Company:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.user?.companyName || ''}</Typography>
                            </>}

                            {(state?.order?.user?.firstName || state?.order?.user?.lastName) && <>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Name:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.user?.firstName || '- Not Supplied -'} {state?.order?.user?.lastName || ''}</Typography>
                            </>}

                            {state?.order?.user?.email && <>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Email:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.user?.email || ''}</Typography>
                            </>}

                            {state?.order?.user?.mobile && <>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Mobile:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.user?.mobile || '- Not Supplied -'}</Typography>
                            </>}

                            {state?.order?.user?.invoicingEmail && <>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Invoicing Email:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.user?.invoicingEmail || '- Not Supplied -'}</Typography>
                            </>}

                          </div>
                      </Grid>
                      <Grid item sm={12} md={6} lg={6} xl={6}>
                        <Typography source={'h2'} style={{ marginTop: 20 }}>Shipping Address</Typography>
                        <div
                          style={{ display: 'flex', flexDirection: 'column' }}
                        > 
                          <Typography source={'h4'} style={{ marginTop: 10 }}>Line 1:</Typography>
                          <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.address?.addressLine1 || ''}</Typography>

                          <Typography source={'h4'} style={{ marginTop: 10 }}>Line 2:</Typography>
                          <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.address?.addressLine2 || ''}</Typography>

                          <Typography source={'h4'} style={{ marginTop: 10 }}>City:</Typography>
                          <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.address?.city || ''}</Typography>

                          <Typography source={'h4'} style={{ marginTop: 10 }}>Postcode:</Typography>
                          <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.address?.postcode || ''}</Typography>

                          <Typography source={'h4'} style={{ marginTop: 10 }}>Region:</Typography>
                          <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.address?.region || ''}</Typography>

                        </div>
                      </Grid>
                    </Grid>

                    <Divider sx={{ marginTop: '30px' }} />
                            
                    <Grid container spacing={[3]} sx={{ paddingBottom: '40px' }}>
                      <Grid item sm={12} md={6} lg={6} xl={6}>
                        <Typography source={'h2'} style={{ marginTop: 40 }}>Products</Typography>
                        <div
                          style={{ display: 'flex', flexDirection: 'column',  gap: 0, width: '100%' }}
                        >
                          {state?.order?.orderItems?.map((item, index) => {
                            return (
                              <div key={index} style={{ display: 'flex', flexDirection: 'column', marginTop: 10 }}>

                                  <Typography source={'p'} style={{ marginRight: 5, fontWeight: 'bold' }}>
                                    - {item?.quantity || ''}x <span style={{ fontWeight: 'normal'}}>|</span>  {item?.productsCode ? `${item.productsCode}` : ''}
                                    {/* {state?.order?.paymentType !== 'Request a Quote' && item?.totalPriceDisplay ? ` - ${item.totalPriceDisplay}` : ''} */}
                                  </Typography>
                                  <Typography source={'p'} style={{ marginLeft: 10, marginRight: 5 }}>{item?.description || ''} {item?.variation ? `(${item.variation})` : ''}</Typography>
                                  


                                {/* <Typography source={'p'} style={{ marginRight: 10}}>- Quantity x{item?.quantity || ''}</Typography> */}
                              </div>
                            )
                          })}

                        </div>

                      </Grid>
                      <Grid item sm={12} md={6} lg={6} xl={6}>

                          <Typography source={'h2'} style={{ marginTop: 40 }}>Payment</Typography>
                          <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                          >

                            <Typography source={'h4'} style={{ marginTop: 10 }}>App Reference:</Typography>
                            <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.reference || ''}</Typography>

                            <Typography source={'h4'} style={{ marginTop: 10 }}>Order Date:</Typography>
                            <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.createdAt ? dayjs(state?.order?.createdAt).format('DD/MM/YYYY') : ''}</Typography>

                            <Typography source={'h4'} style={{ marginTop: 10 }}>Payment Method:</Typography>
                            <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.paymentType || ''}</Typography>

                            {state?.order?.invoiceNumber && <>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Invoice Number:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.invoiceNumber || '- Pending Upload -'}</Typography>
                            </>}

                            {state?.order?.paymentType !== 'Request a Quote' && <>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Subtotal:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.totalPriceDisplay || ''}</Typography>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Shipping:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.shippingPriceDisplay || ''}</Typography>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>VAT:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.vatDisplay || ''}</Typography>
                              <Typography source={'h4'} style={{ marginTop: 10 }}>Total:</Typography>
                              <Typography source={'p'} style={{ marginTop: 0 }}>{state?.order?.grandTotalDisplay || ''}</Typography>
                            </>}
                    
                          </div>
                      </Grid>
                    </Grid>

        
                  




               


                  
                   {state?.order?.invoiceUrl && <div style={{ marginTop: 50 }}>
                    <Button variant='primary'
                      onClick={() => {
                        // open invoiceUrl
                        window.open(state?.order?.invoiceUrl, '_blank')
                      }}
                      icon={MdDownload}
                      icontype={'endIcon'}
                      sx={{
                        alignSelf: 'end'
                      }}
                    >
                      Download Invoice
                    </Button>
                  </div>}
            
                </form>
                <ConfirmationModal
                  onAccept={async () => {
                    await deleteAppUser(state?.user?.id, setAlert)
                    navigate('/dashboard/system')
                  }}
                  isOpen={confirmDelete}
                  onRequestClose={() => setConfirmDelete(false)}
                  type={'Delete'}
                  text={'Are you sure you wish to delete this product?'}
                  icon={MdDeleteForever}
                />
              
              </div>
              {/* <div
                style={{
                  margin: 20,
                  borderLeft: '1px solid grey',
                  minHeight: 600,
                }}
              /> */}
              {/* <div style={{ paddingLeft: 30, paddingRight: 30 }}>
                <Typography source={'h2'} style={{ marginTop: 30 }}>
                  Audit Trail
                </Typography>
                {!audit?.length || audit?.length < 1 ? (
                  <Typography source={'p'} style={{ marginTop: 10 }}>
                    No audit trail found
                  </Typography>
                ) : (
                  <TableContainer source={'audit'} theme={theme}>
                    <Table source={'audit'} theme={theme}>
                      <TableHead source={'audit'} theme={theme}>
                        {['Time', 'Action']?.map((header, index) => {
                          return (
                            <TableCell
                              source={'audit'}
                              key={uuid()}
                              theme={theme}
                            >
                              <Typography>{header}</Typography>
                            </TableCell>
                          )
                        })}
                      </TableHead>
                      {audit?.map((item) => {
                        return (
                          <TableRow source={'audit'} theme={theme} key={uuid()}>
                            <TableCell source={'audit'} theme={theme}>
                              {new Date(item?.updatedAt).toLocaleString()}
                            </TableCell>
                            <TableCell source={'audit'} theme={theme}>
                              {item?.description}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                    </Table>
                  </TableContainer>
                )}
              </div> */}
          </Paper>
        </TabHeader>
      </DashboardContainer>
    </>
  )
}

export default EditOrder
